namespace Matrix.Data {
    export interface BlogPost {
        Title?: string;
        Excerpt?: string;
        CreatedOn?: string;
        CreatedBy?: string;
        Uri?: string;
    }
}
